import * as _ from 'lodash-es';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { POST_BANNER_IMAGE_LIBRARY } from '../components/imageLibraries';
import { EditorActions } from '../editor/editorSlice';

const useAddCover = () => {
  const dispatch = useDispatch();

  return useCallback(async () => {
    const allImages = POST_BANNER_IMAGE_LIBRARY.flatMap(({ images }) => images);
    const randomImage = _.sample(allImages);
    const url = randomImage?.image;

    if (typeof url !== 'string') {
      throw new Error('cover image url must be string');
    }

    const result = await fetch(url);
    const blob = await result.blob();
    const dataUrl = URL.createObjectURL(blob);

    dispatch(EditorActions.setCurrentPostBanner({ image: dataUrl }));
    dispatch(EditorActions.setIsPositioningPostBanner(true));
  }, [dispatch]);
};

export default useAddCover;
